import { Money } from '__generated__/types';
import { Dayjs } from 'utils/dayjs';

import { DEType } from './ExportIncomingsStore';

// alias DEO: DatevExportOutcomings

export interface DEOSearchValues {
  durationFrom: Dayjs;
  durationTo: Dayjs;
  exportType: DEType;
  numbers: string;
  withRegistered: boolean;
}

export interface DEOInvoice {
  id: number;
  number: string;
  issuedAt: string;
  registeredAt: string;
  paidAt: string;
  dealId: number;
  dealNumber: string;
  customer: string;
  amountNetMoney: Money;
  amountNet: number;
  amountBrut: number;
  amountBrutMoney: Money;
  vatAvg: number;
}

export enum ZipStateEnum {
  completed = 'completed',
  failed = 'failed',
  in_progress = 'in_progress',
  not_requested = 'not_requested',
}

export interface DEOItem {
  id: number;
  count: number;
  created: string;
  user: string;
  title: string;
  withCreditNotes: boolean;
  fileId: number;
  accountingPeriod?: string;
  collection?: DEOInvoice[];
  datevCsvPrepaymentReport?: {
    id: number;
    name: string;
  };
  intacctCsvPrepaymentReport?: {
    id: number;
    name: string;
  };
  zipState: ZipStateEnum;
}
